export const SupportedCommunicationTestingControls = {
  Basket: "basket-control",
} as const;

export const getSupportedCommunicationTestingControlTemplates = (): string[] =>
  Object.values(SupportedCommunicationTestingControls);
